import { valibotResolver } from '@hookform/resolvers/valibot';
import { nonEmpty, nonNullable, nullable, number, object, pipe, string } from 'valibot';

export const EQUIPMENT_EDIT_FIELDS = {
  FACILITY_NAME: 'facility_name',
  LOCATION: 'location',
  EQUIPMENT_NAME: 'equipment_name',
  EQUIPMENT_TYPE: 'equipment_type',
  ASSET_CODE: 'asset_code',
};

export const schemaEquipmentEdit = valibotResolver(
  object({
    [EQUIPMENT_EDIT_FIELDS.FACILITY_NAME]: pipe(string(), nonEmpty('This field is required.')),
    [EQUIPMENT_EDIT_FIELDS.LOCATION]: object({
      id: nonNullable(nullable(number('This field is required.')), 'This field is required.'),
    }),
    [EQUIPMENT_EDIT_FIELDS.EQUIPMENT_NAME]: pipe(string(), nonEmpty('This field is required.')),
    [EQUIPMENT_EDIT_FIELDS.EQUIPMENT_TYPE]: object({
      id: nullable(number('This field is required.')),
    }),
    [EQUIPMENT_EDIT_FIELDS.ASSET_CODE]: string(),
  }),
);

export const equipmentEditDefaultValue = (equipmentData) => {
  return {
    [EQUIPMENT_EDIT_FIELDS.FACILITY_NAME]: equipmentData?.facility_name || '',
    [EQUIPMENT_EDIT_FIELDS.LOCATION]: equipmentData?.locationTable,
    [EQUIPMENT_EDIT_FIELDS.EQUIPMENT_NAME]: equipmentData?.name || '',
    [EQUIPMENT_EDIT_FIELDS.EQUIPMENT_TYPE]: equipmentData?.type || { id: null },
    [EQUIPMENT_EDIT_FIELDS.ASSET_CODE]: equipmentData?.asset_code,
  };
};
